import { createFileRoute } from "@tanstack/react-router";
import { DeviceTopologyPage } from "@charphq/ui/components/device/device-topology-page";

export const Route = createFileRoute("/devices_/$deviceId/topology")({
  component: DeviceTopologyComponent,
});

function DeviceTopologyComponent() {
  const { deviceId } = Route.useParams();

  return <DeviceTopologyPage deviceId={deviceId} />;
}
